import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import "../../BranchUser/index.css"

import { TextInputField, Button, DropDownField } from "../../../../helpers";
import { validateInputs } from '../../../../utils';
import { AddCompanyBranchUsersValidationSchema } from '../../../../validation/companyBranchValidation';
import { getPMCompanyConfig } from '../../../../setup/pmCompanyConfig';


const AddUsers = (props) => {
    const { handleAddCompanyBranchUsers, companyId } = props

    const userDetails = useSelector((state) => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.activeUserRoleDetails.companyId)
    const countriesData = useSelector(state => state.common.countries)

    const [userList, setUserList] = useState([
        {
            srNo: 1,
            firstName: '',
            lastName: '',
            phoneNumber: '',
            emailId: '',
            companyId: companyId,
            statusId: 2,
            createdBy: userDetails.userId,
            updatedBy: userDetails.userId
        }
    ])

    const [formErrors, setFormErrors] = useState([])

    const handleIncrement = () => {
        const newUser = {
            srNo: userList.length + 1,
            firstName: '',
            lastName: '',
            phoneNumber: '',
            emailId: '',
            companyId: companyId,
            statusId: 2,
            createdBy: userDetails.userId,
            updatedBy: userDetails.userId,
        }
        setUserList([...userList, newUser])
    }

    const handleDecrement = (key) => {
        let product_index = key

        let newreqarray = []
        let srno = 0;
        userList.map((product, index) => {
            if (index != product_index) {
                if (product != undefined) {
                    srno = srno + 1
                    product.srNo = srno
                    newreqarray.push(product)
                }
            }
        })

        setUserList(newreqarray)
    }

    const handleInputChange = (event, srNo) => {
        event.preventDefault()
        
        setUserList(prevUsers =>
            prevUsers.map(user => 
                user.srNo === srNo ? { ...user, [event.target.name]: event.target.value } : user
            )
        )
    }

    const handleAddUsers = async () => {
        const validation_res = await validateInputs(AddCompanyBranchUsersValidationSchema, userList, pmCompanyConfig)
        
        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
                return
            }
        }

        handleAddCompanyBranchUsers(userList)

        setUserList([
            {
                srNo: 1,
                firstName: '',
                lastName: '',
                phoneNumber: '',
                emailId: '',
                companyId: companyId,
                statusId: 2,
                createdBy: userDetails.userId,
                updatedBy: userDetails.userId,
            }
        ])
    }

    return (
        <div className=''>
        {
            userList.map((user, index) => {
                return (
                    <div className='flex'>
                        <div className="flex flex-column m-3 ml-1 md:my-5 md:mx-3">
                            {user.srNo}
                        </div>
                        <div className="grid">
                            <div className="flex flex-column col-12 mb-2 md:col-3">
                                <TextInputField name="firstName" labelText="First Name" value={user.firstName} onChange={(event) => handleInputChange(event, user.srNo)} errorMessage={formErrors[`[${index}].firstName`]} maxLength={100} />
                            </div>
                            <div className="flex flex-column col-12 mb-2 md:col-3">
                                <TextInputField name="lastName" labelText="Last Name" value={user.lastName} onChange={(event) => handleInputChange(event, user.srNo)} errorMessage={formErrors[`[${index}].lastName`]} maxLength={100} />
                            </div>
                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-1">
                                <DropDownField name="ISDCode" labelText="ISD Code" options={countriesData} optionLabel="ISDCode" optionValue="ISDCode" value={user.ISDCode} onChange={(event) => handleInputChange(event, user.srNo)} errorMessage={formErrors[`[${index}].ISDCode`]} />
                            </div>
                            <div className="flex flex-column col-12 mb-2 md:col-2">
                                <TextInputField name="phoneNumber" labelText="Phone Number" keyfilter={"pnum"} value={user.phoneNumber} onChange={(event) => handleInputChange(event, user.srNo)} errorMessage={formErrors[`[${index}].phoneNumber`]} maxLength={12} />
                            </div>
                            <div className="flex flex-column col-12 mb-2 md:col-3">
                                <TextInputField name="emailId" labelText="Email" value={user.emailId} onChange={(event) => handleInputChange(event, user.srNo)} errorMessage={formErrors[`[${index}].emailId`]} maxLength={100} />
                            </div>
                        </div>
                        {
                            user.srNo == 1 ? "" :
                                <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => handleDecrement(index)} size="large" />
                        }
                    </div>
                )
            })
        }
        <div className="mt-1 ml-2 increment-btn">
            <Button className="increment-btn-icon" icon="pi pi-plus-circle" text onClick={handleIncrement} size="large" />
        </div>
        <div className='mt-3 flex justify-content-end'>
            <Button label="Add Users" onClick={() => handleAddUsers()} />
        </div>
    </div>
    )
}

export default AddUsers;
